module.exports = "<app-header></app-header> <!-- Header  -->\r\n\r\n<router-outlet></router-outlet>\r\n\r\n<app-footer></app-footer> <!-- Footer  -->"